import React, { useEffect } from "react";
import {
  Box,
  Container,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalFooter,
  useDisclosure,
  SimpleGrid,
  Collapse,
  CircularProgress,
  Text,
} from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";
import { useState } from "react";
import { colors } from "../../../theme/styles/colors";
import BreadcrumbBox from "../../../theme/components/breadcrumb";
import TextInput from "../../../theme/components/input/text-input";
import Pagination from "../../../theme/components/pagination/pagination";
import { GET_BREADCRUMB_ROUTES } from "../../../core/utils/navbar-items";
import {
  MENU_NAMES,
  MODULE_ENUMS,
  PAGE_SIZE,
  ROLES,
} from "../../../core/utils/constants";
import { GRID_COLUMNS } from "../../../core/utils/grid-columns";
import { Form, Formik } from "formik";
import * as yup from "yup";
import SelectInput from "../../../theme/components/input/select-input";
import { GoFilter } from "react-icons/go";
import { IoMdAddCircleOutline } from "react-icons/io";
import useTableHeightFix from "../../../core/hooks/useTableHeightFix";
import api from "../../../core/api";
import {
  getFilterCount,
  createFilterPayload,
  deleteById,
  getAll,
  getById,
  handleFilterChange,
  handleResetState,
  CREATE_RESPONSE,
  handleActiveFilter,
  createFilterState,
} from "../../../core/utils/common-function";
import SCHEMA_VALIDATOR from "../../../core/utils/schema-validator";
import DeleteModal from "../../../theme/components/modals/delete-modal";
import SwitchInput from "../../../theme/components/input/switch-input";
import { useSelector } from "react-redux";
import Grid from "../../../theme/components/grid/grid";
import { useLocation } from "react-router-dom";

const VisaCollege = (props) => {
  const location = useLocation();
  const selector = useSelector((_) => _);
  const currentRoute = location.pathname.split('/')[location.pathname.split('/').length - 1];
  const moduleId = selector.auth.login.Permission?.find((x) => x.route == currentRoute)?.moduleId;
  const [topHeight, resizeElementHeight, windowHeight] = useTableHeightFix();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [city, setCity] = useState([]);
  const [visaCollegeId, setVisaCollegeId] = useState(null);
  const [countries, setCountries] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [activeFilter, setActiveFilter] = useState(0);
  const [data, setData] = useState([]);
  const [isLastActiveFilter, setIsLastActiveFilter] = useState(0);
  const hasExport =
    selector.auth.login.RoleId == ROLES.SYSTEM_ADMINISTRATOR ||
    selector.auth.login.RoleId == ROLES.ADMINISTRATOR ||
    selector.auth.login.RoleId == ROLES.BRANCH_HEAD;
  const [columns, setColumns] = useState(
    GRID_COLUMNS.VISA_COLLEGE.filter((x) => x.Active && x.Visibility)
  );
  const [initialState, setInitialState] = useState({
    name: "",
    isActive: false,
  });
  const [filterState, setFilterState] = useState({
    name: "",
    isActive: null,
    visaCountryId: "",
    visaCityId: "",
  });
  const [apiPayload, setAPIPayload] = useState({
    filter: [],
    pageSize: PAGE_SIZE,
    pageIndex: 1,
  });
  const [payload, setPayload] = useState({
    filter: [],
    pageSize: 0,
    pageIndex: 0,
  });

  const onChange = (page) => {
    setAPIPayload({
      ...apiPayload,
      pageIndex: page,
    });
  };
  const handleToggle = () => {
    setShow(!show);
  };
  const { STRING_VALIDATOR, GUID_VALIDATOR } = SCHEMA_VALIDATOR;
  const validationSchema = yup.object({
    name: STRING_VALIDATOR,
    visaCountryId: GUID_VALIDATOR,
    cityId: GUID_VALIDATOR,
  });
  const getAllPromises = () => {
    const getCountriesRequest = getAll("VisaCountry", payload);

    Promise.all([getCountriesRequest])
      .then((res) => {
        const [countryResponse] = res;
        const Countries = countryResponse.data.data.map((countries) => ({
          text: countries.name,
          value: countries.visaCountryId,
        }));
        setCountries(Countries);
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  const getAllRecords = () => {
    api
      .post("/VisaCollege/getAll", apiPayload)
      .then((res) => {
        setTotalCount(res.data.data.total);
        setDataSource(res.data.data.data);
        setData(CREATE_RESPONSE(GRID_COLUMNS.VISA_COLLEGE, res.data.data.data));
      })
      .catch((err) => { });
  };
  const getRecord = async () => {
    try {
      if (visaCollegeId) {
        let visaCollege = (await getById("visaCollege", visaCollegeId)).data;
        setInitialState({
          isActive: visaCollege.isActive,
          name: visaCollege.name,
          ...visaCollege,
        });
        onOpen();
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    document.title = "Visa College | Digital Filing";
    if (isLastActiveFilter == 0)
      lastActiveFilter();
    else {
      getAllRecords();
      getAllPromises();
      resizeElementHeight(
        document.getElementsByClassName("chakra-table__container")[0]
      );
    }
  }, [apiPayload]);

  useEffect(() => {
    getRecord();
  }, [isEdit, isView]);

  useEffect(() => {
    setData(CREATE_RESPONSE(columns, dataSource));
  }, [columns]);

  useEffect(() => {
    resizeElementHeight(
      document.getElementsByClassName("chakra-table__container")[0]
    );
  }, [windowHeight]);

  const onModelClose = () => {
    setVisaCollegeId(null);
    setIsEdit(false);
    setIsView(false);
    onClose();
    setInitialState({
      isActive: false,
      name: "",
    });
  };

  const onDelete = async () => {
    await deleteById("visaCollege", visaCollegeId);
    getAllRecords();
    setIsDeleteOpen(false);
    onModelClose();
  };
  const resetFilterState = () => {
    setAPIPayload({
      ...apiPayload,
      filter: [],
      pageIndex: 1,
      pageSize: PAGE_SIZE,
    });
    handleActiveFilter('delete', moduleId)
    handleResetState(filterState, setFilterState);
    setActiveFilter(0);
  };

  const lastActiveFilter = async () => {
    let filledFilter = [];
    const lastFilter = await handleActiveFilter('get', moduleId);
    if (lastFilter) {
      filledFilter = JSON.parse(lastFilter.data.data);
      if (filledFilter) {
        createFilterState(filledFilter, setFilterState, setActiveFilter);
      }
    }
    setAPIPayload({
      ...apiPayload,
      filter: filledFilter ? filledFilter : [],
      pageSize: PAGE_SIZE,
      pageIndex: 1,
    });
    setIsLastActiveFilter(1);
  };

  return (
    <Box>
      <DeleteModal
        isOpen={isDeleteOpen}
        onClose={() => {
          setIsDeleteOpen(false);
        }}
        onDelete={onDelete}
      />
      <Container maxW="container.xll" padding={"20px"} paddingBottom={"0px"}>
        <Box>
          <BreadcrumbBox
            route={GET_BREADCRUMB_ROUTES(MENU_NAMES.VISA_COLLEGE)}
          />
        </Box>
        <Box
          color={colors.white}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          marginBottom={"20px"}
        >
          <Box>
            <Heading variant={"h1"}>Visa College</Heading>
          </Box>
          <Box display={"flex"} alignItems={"center"} gap={"20px"}>
            <Button onClick={handleToggle} variant={"secondary"}>
              <GoFilter fontSize={"20px"} />
              <Text marginLeft={"5px"} className="btnText">
                Filter
              </Text>
              <Box
                position={"absolute"}
                top={"-19px"}
                right={"-1"}
                backgroundColor={colors.primaryColor}
                color={colors.white}
                borderRadius={"16px"}
                padding={"0px"}
                height={"30px"}
                width={"30px"}
                lineHeight={"30px"}
              >
                {activeFilter}
              </Box>
            </Button>
            {props.hasCreate && (
              <Button variant={"primary"} onClick={onOpen}>
                <IoMdAddCircleOutline fontSize={"20px"} />
                <Text marginLeft={"5px"} className="btnText">
                  Create New
                </Text>
              </Button>
            )}
          </Box>
        </Box>
        <Box
          backgroundColor={colors.white}
          boxShadow={"0px 0px 35px 0px #F5F5F5"}
          borderRadius={"10px"}
          marginBottom={"20px"}
        >
          <Collapse in={show}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                const payloadArr = createFilterPayload(filterState);
                const filterSum = getFilterCount(filterState);
                setActiveFilter(filterSum);
                setAPIPayload({
                  ...apiPayload,
                  filter: payloadArr,
                  pageSize: PAGE_SIZE,
                  pageIndex: 1,
                });
                const jsonString = JSON.stringify(payloadArr);
                handleActiveFilter('post', '', { moduleId: moduleId, StateJson: jsonString })

              }}
            >
              <SimpleGrid
                columns={{ base: "1", sm: "1", md: "4", lg: "4" }}
                spacingX="40px"
                padding={"20px"}
                paddingBottom={"0px"}
              >
                <TextInput
                  type="text"
                  placeholder={""}
                  name="Name"
                  value={filterState.Name?.value}
                  onChange={(e) =>
                    handleFilterChange(e, filterState, setFilterState, "Name")
                  }
                  marginTop="20px"
                  formControl={{ id: "name" }}
                  label={{ text: "Name" }}
                />
                <SelectInput
                  formControl={{ id: "isActive", variant: "floating" }}
                  isRequired={false}
                  isReadOnly={false}
                  value={filterState.IsActive?.value}
                  name="IsActive"
                  onChange={(e) =>
                    handleFilterChange(e, filterState, setFilterState, "Status")
                  }
                  label={{
                    text: "Status",
                  }}
                  options={[
                    { text: "Active", value: true },
                    { text: "Inactive", value: false },
                  ]}
                />
                <SelectInput
                  formControl={{ id: "visaCountryId", variant: "floating" }}
                  isRequired={false}
                  isReadOnly={true}
                  value={filterState.VisaCountryId?.value}
                  name="VisaCountryId"
                  onChange={(e) => {
                    handleFilterChange(e, filterState, setFilterState, "Visa Country");
                    api
                      .get(`VisaCity/getByCountry/${e.target.value}`)
                      .then((res) => {
                        const City = res.data.data.map((city) => ({
                          text: city.name,
                          value: city.VisaCityId,
                        }));
                        setCity(City);
                      })
                      .catch((err) => {
                        console.log(err, "err");
                      });
                  }}
                  label={{
                    text: "Visa Country",
                  }}
                  options={countries}
                />
                <SelectInput
                  formControl={{ id: "visaCityId", variant: "floating" }}
                  isRequired={false}
                  // isReadOnly={false}
                  value={filterState.VisaCityId?.value}
                  name="VisaCityId"
                  onChange={(e) =>
                    handleFilterChange(e, filterState, setFilterState, "Visa City")
                  }
                  label={{
                    text: "Visa City",
                  }}
                  options={city}
                />
              </SimpleGrid>
              <Box
                display={"flex"}
                justifyContent={"end"}
                paddingRight={"20px"}
                paddingBottom={"20px"}
              >
                <Button
                  fontSize={{
                    base: "12px",
                    sm: "13px",
                    md: "14px",
                    lg: "14px",
                  }}
                  variant={"primary"}
                  type="submit"
                >
                  Search
                </Button>
                <Button
                  fontSize={{
                    base: "12px",
                    sm: "13px",
                    md: "14px",
                    lg: "14px",
                  }}
                  variant={"warning"}
                  marginLeft={"10px"}
                  isDisabled={activeFilter > 0 ? false : true}
                  onClick={resetFilterState}
                >
                  Reset
                </Button>
              </Box>
            </form>
          </Collapse>
        </Box>
        <Grid
          name={"visaCollege"}
          columns={GRID_COLUMNS.VISA_COLLEGE}
          aColumns={columns}
          data={data}
          permission={props}
          hasDelete={true}
          hasExport={hasExport}
          setColumns={(e) => setColumns(e)}
          isPopupComponent={true}
          setRecordId={(id, props) => {
            if (props.isView) {
              setIsView(true);
              setIsEdit(false);
            } else if (props.isEdit) {
              setIsView(false);
              setIsEdit(true);
            } else if (props.isDelete) setIsDeleteOpen(true);
            setVisaCollegeId(id);
          }}
        />
        <Pagination
          className="pagination-bar"
          currentPage={apiPayload.pageIndex}
          totalCount={totalCount}
          pageSize={apiPayload.pageSize}
          onPageChange={(page) =>
            setAPIPayload({
              ...apiPayload,
              pageIndex: page,
            })
          }
          activeBackgroundColor={colors.primaryColor}
          activeTextColor={colors.gray.gray100}
          onChange={onChange}
        />
      </Container>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onModelClose}
        minWidth={"20%"}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <Formik
            validationSchema={validationSchema}
            initialValues={initialState}
            enableReinitialize={true}
            onSubmit={(values) => {
              let finalPayload = {
                visaCountryId: values.visaCountryId,
                visaCityId: values.visaCityId,
                name: values.name,
                isActive: values.isActive,
              };
              if (isEdit) {
                finalPayload.visaCollegeId = visaCollegeId;
                api
                  .put(`/VisaCollege/replace`, { ...finalPayload })
                  .then((res) => {
                    onClose();
                    getAllRecords();
                  })
                  .catch((err) => {
                    console.log(err, "err");
                  });
                return;
              }
              api
                .post(`/VisaCollege/create`, { ...finalPayload })
                .then((res) => {
                  onClose();
                  getAllRecords();
                })
                .catch((err) => {
                  console.log(err, "err");
                });
            }}
          >
            {({ handleSubmit, handleChange, values, errors }) => (
              <Form
                noValidate={true}
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <ModalHeader borderBottom={"1px solid #EDEDED"}>
                  {isEdit
                    ? "Update Visa College"
                    : isView
                      ? "View Visa College"
                      : "Create Visa College"}
                </ModalHeader>
                <ModalCloseButton
                  bg={colors.primaryColor}
                  color={colors.white}
                  position={"absolute"}
                  top={"15px"}
                  onClick={onModelClose}
                />
                <ModalBody padding={"20px"}>
                  <SimpleGrid
                    columns={{ base: "1", sm: "1", md: "1", lg: "1" }}
                    spacingX="-3px"
                    spacingY="-6px"
                    gap={"10px"}
                  >
                    <TextInput
                      marginTop="20px"
                      type="text"
                      name="name"
                      isRequired={true}
                      isReadOnly={isView}
                      placeholder={""}
                      value={values.name}
                      label={{
                        text: "Name",
                        colors: errors.name ? "red !important" : "",
                        variant: errors.name ? "errored" : "",
                      }}
                      onChange={(e) => handleChange(e)}
                      variant={errors.name ? "errored" : "flushed"}
                    />
                    <SelectInput
                      formControl={{
                        id: "visaCountryId",
                        variant: "floating",
                      }}
                      isRequired={true}
                      isReadOnly={isView}
                      value={values.visaCountryId}
                      label={{
                        text: "Visa Countries",
                        colors: errors.visaCountryId ? "red !important" : "",
                        variant: errors.visaCountryId ? "errored" : "",
                      }}
                      name="visaCountryId"
                      options={countries}
                      onChange={(e) => {
                        handleChange(e);
                        api
                          .get(`VisaCity/getByCountry/${e.target.value}`)
                          .then((res) => {
                            const City = res.data.data.map((city) => ({
                              text: city.name,
                              value: city.visaCityId,
                            }));
                            setCity(City);
                          })
                          .catch((err) => {
                            console.log(err, "err");
                          });
                      }}
                      variant={errors.visaCountryId ? "errored" : "flushed"}
                    />
                    <SelectInput
                      formControl={{
                        id: "cityId",
                        variant: "floating",
                      }}
                      name="cityId"
                      isRequired={true}
                      isReadOnly={isView}
                      value={values.cityId}
                      label={{
                        text: "Visa City",
                        colors: errors.cityId ? "red !important" : "",
                        variant: errors.cityId ? "errored" : "",
                      }}
                      options={city}
                      variant={errors.cityId ? "errored" : "flushed"}
                      onChange={handleChange}
                    />
                    <SwitchInput
                      placeholder={""}
                      isRequired={true}
                      isReadOnly={isView}
                      value={values.isActive}
                      name="isActive"
                      variant={errors.isActive ? "errored" : "flushed"}
                      label={{
                        text: "Active",
                        colors: errors.isActive ? "red !important" : "",
                        variant: errors.isActive ? "errored" : "",
                        fontSize: "12px",
                      }}
                      formControl={{ id: "isActive" }}
                      onChange={handleChange}
                    />
                  </SimpleGrid>
                </ModalBody>
                <ModalFooter
                  justifyContent={"space-between"}
                  borderTop={"1px solid #EDEDED "}
                >
                  <Button variant={"secondaryOutline"} onClick={onModelClose}>
                    Discard
                  </Button>
                  {!isView && (
                    <Button
                      variant={"primary"}
                      color={colors.white}
                      type="submit"
                    >
                      {isLoading ? (
                        <CircularProgress
                          isIndeterminate
                          size="24px"
                          color={colors.white}
                        />
                      ) : isEdit ? (
                        "Save"
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  )}
                </ModalFooter>
              </Form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </Box>
  );
};
export default VisaCollege;
